import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  TextField,
  Container,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import { useParams, Link } from "react-router-dom";
import { providers } from "../../api/providers";
import { budget } from "../../api/budget";
import { useNotification } from "../../context/notification.context";
import AddIcon from "@mui/icons-material/Add";
import { TableComponent } from "../../components/Table"; // Asegúrate de proporcionar la ruta correcta a tu componente Table
import { GridColDef } from "@mui/x-data-grid";
import { Payment } from "../payments/interface/pay.interface";
import { ModalComponent } from "../../components";
import { ModalPaymentComponent, ModalProductComponent } from "../../components";
import { Provider } from "./interface/provider.interface";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


export const ProviderPage: React.FC<{}> = () => {
  const { id } = useParams();
  const { getError, getSuccess } = useNotification();
  const [provider, setProvider] = useState<any>(null);
  const [allBudgets, setAllBudgets] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<Payment | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<Payment | null>(null);
  const [isModalProviderOpen, setIsModalProviderOpen] = useState(false);
  const [isModalPaymentOpen, setIsModalPaymentOpen] = useState(false);
  const [isModalProductOpen, setIsModalProductOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<Provider | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const [debtBudgets, setDebtBudgets] = useState<any[]>([]);
  const [showAll, setShowAll] = useState(false);

  const [dialogProductOpen, setDialogProductOpen] = useState(false);
  const [productIdToDelete, setProductIdToDelete] = useState<number>();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!deleted) {
          const response = await providers.getById(id as any);

          // Normaliza moneda de DB2 ("USD"→"U$S", "ARS"→"$") para compatibilidad con el resto del UI
          const normalizeMoneda = (items: any[]) => items.map(i => ({
            ...i,
            moneda: i.moneda === "USD" ? "U$S" : i.moneda === "ARS" ? "$" : i.moneda
          }));

          const hoteles = normalizeMoneda(Array.isArray(response.data?.presupuestosHoteles) ? response.data.presupuestosHoteles : []);
          const vuelos = normalizeMoneda(Array.isArray(response.data?.presupuestosLineas) ? response.data.presupuestosLineas : []);
          const servicios = normalizeMoneda(Array.isArray(response.data?.presupuestosServicios) ? response.data.presupuestosServicios : []);

          const providerData = {
            id: response.data.id,
            nombre: response.data.nombre,
            mail: response.data.mail,
            domicilio: response.data.domicilio,
            comentarios: response.data.comentarios,
            tel: response.data.tel,
            pagos: response.data.pagos,
            hoteles: hoteles,
            vuelos: vuelos,
            servicios: servicios,
            saldo_ars: 0,
            saldo_usd: 0
          };

          const budgetData: {
            id: string;
            file: string;
            tipo: string;
            moneda: string;
            total_ars: string;
            pagado_ars: string;
            saldo_ars: string;
            total_usd: string;
            pagado_usd: string;
            saldo_usd: string;
            producto: string;
            concepto: string;
            descripcion: string;
            fecha: Date | null;
            cliente: string;
            vendedor: string;
            facturas: string;
            importe: string
          }[] = [];

          const debtData: {
            id: string;
            file: string;
            tipo: string;
            moneda: string;
            total_ars: string;
            pagado_ars: string;
            saldo_ars: string;
            total_usd: string;
            pagado_usd: string;
            saldo_usd: string;
            producto: string;
            concepto: string;
            descripcion: string;
            fecha: Date | null;
            cliente: string;
            vendedor: string;
            facturas: string;
            importe: string
          }[] = [];

          providerData.hoteles.forEach((item: any) => {
            if (item.eliminado !== 1 && item.presupuesto !== null && item.presupuesto.eliminado !== 1) {

              const budget = {
                id: "h_" + item.id,
                file: item.file,
                tipo: "Alojamiento",
                moneda: item.moneda,
                total_ars: (item.moneda === "$") ? formatNumber(item.costo) : "",
                pagado_ars: (item.moneda === "$") ? formatNumber(item.totalPaid) : "",
                saldo_ars: (item.moneda === "$") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                total_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.costo) : "",
                pagado_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.totalPaid) : "",
                saldo_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                producto: item.presupuesto.id,
                concepto: item.presupuesto.concepto,
                descripcion: item.presupuesto.descripcion,
                fecha: (item.fecha_salida !== null) ? new Date(item.fecha_salida) : new Date(item.presupuesto.fecha_salida),
                cliente: (item.presupuesto.nombre_cliente !== null) ? item.presupuesto.nombre_cliente.toUpperCase() : "",
                vendedor: (item.presupuesto.user !== null) ? item.presupuesto.user.nombre.toUpperCase() : "",
                facturas: item.facturas,
                importe: item.costo
              }

              budgetData.push(budget);
              if (item.saldo >= 1) {
                debtData.push(budget);
              }

              providerData.saldo_ars += (item.moneda === "$" && item.saldo > 0) ? item.saldo : 0;
              providerData.saldo_usd += ((item.moneda === "U$S" || item.moneda === "U$D") && item.saldo > 0) ? item.saldo : 0;
            }
          });
          providerData.vuelos.forEach((item: any) => {
            if (item.eliminado !== 1 && item.presupuesto !== null && item.presupuesto.eliminado !== 1) {

              const budget = {
                id: "l_" + item.id,
                file: item.file,
                tipo: "Aéreo",
                moneda: item.moneda,
                total_ars: (item.moneda === "$") ? formatNumber(item.costo) : "",
                pagado_ars: (item.moneda === "$") ? formatNumber(item.totalPaid) : "",
                saldo_ars: (item.moneda === "$") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                total_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.costo) : "",
                pagado_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.totalPaid) : "",
                saldo_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                producto: item.presupuesto.id,
                concepto: item.presupuesto.concepto,
                descripcion: item.presupuesto.descripcion,
                fecha: (item.fecha_salida !== null) ? new Date(item.fecha_salida) : new Date(item.presupuesto.fecha_salida),
                cliente: (item.presupuesto.nombre_cliente !== null) ? item.presupuesto.nombre_cliente.toUpperCase() : "",
                vendedor: (item.presupuesto.user !== null) ? item.presupuesto.user.nombre.toUpperCase() : "",
                facturas: item.facturas,
                importe: item.costo
              }

              budgetData.push(budget);
              if (item.saldo >= 1) {
                debtData.push(budget);
              }
              providerData.saldo_ars += (item.moneda === "$" && item.saldo > 0) ? item.saldo : 0;
              providerData.saldo_usd += ((item.moneda === "U$S" || item.moneda === "U$D") && item.saldo > 0) ? item.saldo : 0;
            }
          });
          providerData.servicios.forEach((item: any) => {
            if (item.eliminado !== 1 && item.presupuesto !== null && item.presupuesto.eliminado !== 1) {

              const budget = {
                id: "s_" + item.id,
                file: item.file,
                tipo: "Servicio",
                moneda: item.moneda,
                total_ars: (item.moneda === "$") ? formatNumber(item.costo) : "",
                pagado_ars: (item.moneda === "$") ? formatNumber(item.totalPaid) : "",
                saldo_ars: (item.moneda === "$") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                total_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.costo) : "",
                pagado_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? formatNumber(item.totalPaid) : "",
                saldo_usd: (item.moneda === "U$S" || item.moneda === "U$D") ? (item.saldo >= 1) ? formatNumber(item.saldo) : "" : "",
                producto: item.presupuesto.id,
                concepto: item.presupuesto.concepto,
                descripcion: item.presupuesto.descripcion,
                fecha: (item.fecha_salida !== null) ? new Date(item.fecha_salida) : new Date(item.presupuesto.fecha_salida),
                cliente: (item.presupuesto.nombre_cliente !== null) ? item.presupuesto.nombre_cliente.toUpperCase() : "",
                vendedor: (item.presupuesto.user !== null) ? item.presupuesto.user.nombre.toUpperCase() : "",
                facturas: item.facturas,
                importe: item.costo
              }

              budgetData.push(budget);
              if (item.saldo >= 1) {
                debtData.push(budget);
              }
              providerData.saldo_ars += (item.moneda === "$" && item.saldo > 0) ? item.saldo : 0;
              providerData.saldo_usd += ((item.moneda === "U$S" || item.moneda === "U$D") && item.saldo > 0) ? item.saldo : 0;
            }
          });

          setProvider({
            id: providerData.id,
            nombre: providerData.nombre,
            mail: providerData.mail,
            domicilio: providerData.domicilio,
            comentarios: providerData.comentarios,
            tel: providerData.tel,
            saldoARS: formatNumber(providerData.saldo_ars),
            saldoUSD: formatNumber(providerData.saldo_usd)
          });

          const sortedDates = budgetData?.map(obj => { return { ...obj, date: obj.fecha } }).sort((a: any, b: any) => (b.fecha !== null && a.fecha !== null) ? a.fecha - b.fecha : 0);
          setAllBudgets(sortedDates);

          const sortedDebts = debtData?.map(obj => { return { ...obj, date: obj.fecha } }).sort((a: any, b: any) => (b.fecha !== null && a.fecha !== null) ? a.fecha - b.fecha : 0);
          setDebtBudgets(sortedDebts);
        }
      } catch (error) {
        getError(
          `Ocurrió un error inesperado al cargar los proveedores: ${error}`
        );
      }
    };

    fetchData();
  }, [deleted, getError, id, showAll]);

  // Function to format numbers with custom separators
  const formatNumber = (number: any) => {
    return number.toLocaleString('es', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
      groupingSeparator: '.',
      decimalSeparator: ',',
    });
  };

  //Providers Actions
  const handleEditProvider = async (editedProvider: Provider) => {
    try {
      setIsLoading(true);
      if (selectedProvider && selectedProvider.id !== undefined) {
        await providers.update(
          selectedProvider.id,
          editedProvider
        );
        getSuccess("Proveedor actualizado correctamente");
        setIsModalProviderOpen(false);
      }
      setIsLoading(false);
    } catch (error) {
      getError("Error al actualizar el proveedor");
    }
  };
  const handleEditModalProviderOpen = (provider: Provider) => {
    setSelectedProvider(provider);
    setIsModalProviderOpen(true);
  };
  const handleEditModalProviderClose = () => {
    setSelectedProvider(null);
    setIsModalProviderOpen(false);
  };
  const handleModalProviderClose = () => {
    setIsModalProviderOpen(false);
  };
  const handleDeleteProvider = async (id: number) => {
    try {
      setIsLoading(true);
      await providers.delete(id);
      setDeleted(true);
      navigate(`/proveedores`);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      getSuccess("Proveedor eliminado correctamente");
    } catch (error) {
      getError(`Error al eliminar el elemento: ${error}`);
    }
  };

  //Payments Actions
  const handleAddPayment = () => {
    window.location.reload();
  };
  const handleModalPaymentOpen = () => {
    setSelectedPayment(null);
    setIsModalPaymentOpen(true);
  };
  const handleModalPaymentClose = () => {
    setIsModalPaymentOpen(false);
  };
  const handleEditModalPaymentClose = () => {
    setSelectedPayment(null);
    setIsModalPaymentOpen(false);
  };
  const handlePaymentsToShow = () => {
    setShowAll(!showAll);
  }

  //Product Actions
  const handleAddProduct = () => {
    window.location.reload();
  };
  const handleModalProductOpen = () => {
    setIsModalProductOpen(true);
  };
  const handleModalEditProductOpen = (product: any) => {
    setSelectedProduct(product);
    setIsModalProductOpen(true);
  };
  const handleModalProductClose = () => {
    setSelectedProduct(null);
    setIsModalProductOpen(false);
  };
  const handleEditModalProductClose = () => {
    setSelectedProduct(null);
    setIsModalProductOpen(false);
  };
  const handleProductDialogOpen = (id: string) => {
    setProductIdToDelete(parseInt(id));
    setDialogProductOpen(true);
  };
  const handleDeleteProducto = async (id: number) => {
    try {
      setIsLoading(true);
      await budget.delete(id.toString());
      getSuccess("Producto eliminado correctamente");
      setDialogProductOpen(false);
      setIsLoading(false);
    } catch (error) {
      getError(`Error al eliminar el elemento: ${error}`);
    }
  };
  //

  if (!provider || isLoading) {
    return <CircularProgress sx={{
      position: 'absolute',
      top: '50%',
      left: '50%'
    }} />;
  }

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogProductOpen(false);
  };

  const columns: GridColDef[] = [
    {
      field: "fecha",
      headerName: "Viaje",
      width: 120,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      type: "date",
      valueGetter: ({ value }) => value,
    },
    {
      field: "file",
      headerName: "File",
      width: 90,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      type: "number"
    },
    {
      field: "cliente",
      headerName: "Cliente",
      width: 180,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true
    },
    {
      field: "total_ars",
      headerName: "Total ARS",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_ars",
      type: "text",
      sortable: false
    },
    {
      field: "pagado_ars",
      headerName: "Pagado",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_ars",
      type: "text",
      sortable: false
    },
    {
      field: "saldo_ars",
      headerName: "Saldo ARS",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_ars",
      type: "text",
      sortable: false
    },
    {
      field: "total_usd",
      headerName: "Total USD",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_usd",
      type: "text",
      sortable: false
    },
    {
      field: "pagado_usd",
      headerName: "Pagado",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_usd",
      type: "text",
      sortable: false
    },
    {
      field: "saldo_usd",
      headerName: "Saldo USD",
      width: 130,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      cellClassName: "column_usd",
      type: "text",
      sortable: false
    },
    {
      field: "tipo",
      headerName: "Tipo",
      width: 120,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true
    },
    {
      field: "vendedor",
      headerName: "Vendedor",
      width: 150,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true
    },
    {
      field: "producto",
      headerName: "Producto",
      width: 100,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true
    },
  ];

  return (
    <div>
      <Container maxWidth="xl" sx={{ pt: 5 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          <IconButton aria-label="routeback" size="small" component={Link} to="/proveedores">
            <ArrowBackIos fontSize="small" />
          </IconButton>
          Información del Proveedor
        </Typography>

        <Grid container sx={{ mb: 3 }}>
          <Grid item xs={3} sx={{ pr: 3 }}>
            <TextField
              label="Nombre"
              key="nombre"
              value={provider.nombre || ""}
              disabled={true}
              fullWidth
            />
          </Grid>
          <Grid item xs={2} sx={{ pr: 3 }}>
            <TextField
              label="Teléfono"
              key="tel"
              value={provider.tel || ""}
              disabled={true}
              fullWidth
            />
          </Grid>
          <Grid item xs={3} sx={{ pr: 3 }}>
            <TextField
              key="mail"
              label="Correo Electrónico"
              value={provider.mail || ""}
              disabled={true}
              fullWidth
            />
          </Grid>
          <Grid item xs={3} sx={{ pr: 3 }}>
            <TextField
              key="domicilio"
              label="Domicilio"
              value={provider.domicilio || ""}
              disabled={true}
              fullWidth
            />
          </Grid>
          <Grid item xs={1} >
            <IconButton aria-label="edit" size="medium" sx={{ mt: 1 }} onClick={() => handleEditModalProviderOpen(provider)}>
              <EditIcon fontSize="small" />
            </IconButton>

            <IconButton aria-label="delete" size="medium" sx={{ mt: 1 }} onClick={handleDialogOpen}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 3 }}>
          <Grid item xs={2} sx={{ pr: 3 }}>
            <TextField
              label="Saldo ARS"
              key="saldoArs"
              value={"$ " + provider.saldoARS}
              disabled={true}
              fullWidth
              color="warning"
            />
          </Grid>
          <Grid item xs={2} sx={{ pr: 3 }}>
            <TextField
              label="Saldo USD"
              key="saldoArs"
              value={"U$S " + provider.saldoUSD}
              disabled={true}
              fullWidth
            />
          </Grid>
        </Grid>
      </Container>
      <Paper variant="outlined" />
      <Container maxWidth="xl">
        <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
          Productos Comprados
        </Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ mb: 2, mt: 2 }}
          startIcon={<AddIcon />}
          onClick={handleModalPaymentOpen}
          style={{ float: "right" }}
        >
          Agregar pago
        </Button>

        <Button
          size="medium"
          variant="outlined"
          sx={{ mt: 2, mb: 2, mr: 2 }}
          startIcon={<AddIcon />}
          onClick={handleModalProductOpen}
          style={{ float: "right" }}
        >
          Agregar Producto
        </Button>

        <FormGroup sx={{ mt: 2, mb: 2 }}>
          <FormControlLabel control={<Switch onChange={handlePaymentsToShow} />} label="Mostrar solo con saldos" />
        </FormGroup>

        {allBudgets ? (
          showAll ? (
            <TableComponent
              columnData={columns}
              rowData={allBudgets}
              actions={true}
              actionsType={"products"}
              onEdit={handleModalEditProductOpen}
              onDelete={handleProductDialogOpen}
              exportTitle={"Listado de Productos - " + provider.nombre}
            />
          ) : (
            <TableComponent
              columnData={columns}
              rowData={debtBudgets}
              actions={true}
              actionsType={"products"}
              onEdit={handleModalEditProductOpen}
              onDelete={handleProductDialogOpen}
              exportTitle={"Listado de Productos - " + provider.nombre}
            />
          )
        ) : (
          <Typography variant="body1">Cargando productos...</Typography>
        )}

        <ModalComponent
          open={isModalProviderOpen}
          onClose={handleModalProviderClose}
          onSave={handleEditProvider}
          onCancel={handleEditModalProviderClose}
          title={"Editar Proveedor"}
          fields={[
            { label: "Nombre", key: "nombre" },
            { label: "Domicilio", key: "domicilio" },
            { label: "Teléfono", key: "tel" },
            { label: "E-mail", key: "mail" },
            { label: "Comentarios", key: "comentarios" },
          ]}
          initialData={selectedProvider}
        />

        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Eliminar Proveedor
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea eliminar el proveedor?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancelar</Button>
            <Button onClick={() => { handleDeleteProvider(provider.id); }} autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={dialogProductOpen}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Eliminar Producto
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea eliminar el producto?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancelar</Button>
            <Button onClick={() => { handleDeleteProducto(productIdToDelete ?? 0); }} autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        <ModalPaymentComponent
          open={isModalPaymentOpen}
          onClose={handleModalPaymentClose}
          onSave={handleAddPayment}
          onCancel={handleEditModalPaymentClose}
          title={"Agregar Pago | " + provider.nombre}
          files={allBudgets}
          providerID={provider.id}
          initialData={selectedPayment}
        />

        <ModalProductComponent
          open={isModalProductOpen}
          onClose={handleModalProductClose}
          onSave={handleAddProduct}
          onCancel={handleEditModalProductClose}
          title={(selectedProduct) ? 'Editar Producto | ' + provider.nombre : 'Agregar Producto | ' + provider.nombre}
          providerId={provider?.id || parseInt(id as string)}
          initialData={selectedProduct}
        />
      </Container>
    </div>
  );
};
